import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import ScrollTrigger from "gsap/ScrollTrigger"; // ScrollTrigger を追加

gsap.registerPlugin(CustomEase, ScrollTrigger);

export function fvText() {
    gsap.timeline({
        duration:.5,
    })
    .to('.js-slide-text--mv', {
        visibility: 'visible',
        delay:.7,
    })
    .to('.p-top-mv__head', {
        visibility: 'visible',
        delay:.7,
        
    })
    .from('.js-txt-animation01', {
        opacity:0,
        
    })
    .from('.p-top-mv__deco-line01', {
        opacity:0,
        
    })
    .from('.p-top-mv__heading-txt01', {
        opacity:0,
        
    })
    .from('.js-txt-animation02', {
        opacity:0,
        
    })
    .from('.p-top-mv__deco-line02', {
        opacity:0,
        
    })
    .from('.p-top-mv__heading-txt02', {
        opacity:0,
        
    })
    /*===========================
    // fv chenge
    ===========================*/
    const headerChangeTrigger = document.querySelector(".js-fv-scroll");
    if (headerChangeTrigger != null) {
        ScrollTrigger.create({
            trigger: headerChangeTrigger,
            start: "top top", // スクロールが始まる位置
            onEnter: () => document.querySelector('.p-top-mv').classList.add('p-top-mv--change'),
            onLeaveBack: () => document.querySelector('.p-top-mv').classList.remove('p-top-mv--change'),
        });
    }
}